import {DlMuiButton} from '@wallaby-ui/core';
import {useFormatters} from '@wallaby-ui/document';
import React from 'react';
import {Modal} from 'react-bootstrap';

type DialogMode = 'list' | 'create' | 'edit' | 'edit-shortcuts';

type Props = {
  mode: DialogMode;
  isValid: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onBack: () => void;
  onSave: () => void;
  onSaveShortcuts: () => void;
};

export const DialogFooter: React.FC<Props> = ({mode, isValid, isSubmitting, onClose, onBack, onSave, onSaveShortcuts}) => {
  const {t} = useFormatters();

  if (mode === 'list') {
    return (
      <Modal.Footer style={{border: 'none', justifyContent: 'space-between'}}>
        <div />
        <DlMuiButton style={{height: 30, width: 140}} type='chip-gray' title={t('common.confirmDialog.close')} onClick={onClose} />
      </Modal.Footer>
    );
  }

  if (mode === 'edit-shortcuts') {
    return (
      <Modal.Footer style={{border: 'none', justifyContent: 'space-between'}}>
        <DlMuiButton
          style={{height: 30, width: 140}}
          type='chip-gray'
          title={t('common.confirmDialog.back')}
          onClick={onBack}
          disabled={isSubmitting}
        />
        <DlMuiButton
          style={{height: 30, width: 140}}
          type='chip-filled'
          title={t('common.confirmDialog.save')}
          onClick={onSaveShortcuts}
          disabled={!isValid || isSubmitting}
        />
      </Modal.Footer>
    );
  }

  // create or edit mode
  return (
    <Modal.Footer style={{border: 'none', justifyContent: 'space-between'}}>
      <DlMuiButton
        style={{height: 30, width: 140}}
        type='chip-gray'
        title={t('common.confirmDialog.back')}
        onClick={onBack}
        disabled={isSubmitting}
      />
      <DlMuiButton
        style={{height: 30, width: 140}}
        type='chip-filled'
        title={mode === 'edit' ? t('common.confirmDialog.save') : t('hospitalization.detail.phRec.combination.create.button')}
        onClick={onSave}
        disabled={!isValid || isSubmitting}
      />
    </Modal.Footer>
  );
};
